import * as Types from '../../../@graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type FetchPushsQueryVariables = Types.Exact<{
  first?: Types.Maybe<Types.Scalars['Int']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
  after?: Types.Maybe<Types.Scalars['String']>;
  filter?: Types.Maybe<Types.PushsFilter>;
  sort?: Types.Maybe<Types.PushsSort>;
}>;


export type FetchPushsQuery = (
  { __typename?: 'Query' }
  & { pushs: (
    { __typename?: 'PushsConnection' }
    & { edges: Array<Types.Maybe<(
      { __typename?: 'PushsEdge' }
      & Pick<Types.PushsEdge, 'cursor'>
      & { node?: Types.Maybe<(
        { __typename?: 'Push' }
        & Pick<Types.Push, 'id' | 'uid' | 'title' | 'content' | 'link' | 'createdAt'>
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<Types.PageInfo, 'hasPreviousPage' | 'hasNextPage' | 'endCursor'>
    ) }
  ) }
);

export type CreatePushMutationVariables = Types.Exact<{
  data: Types.CreatePushInput;
}>;


export type CreatePushMutation = (
  { __typename?: 'Mutation' }
  & { createPush?: Types.Maybe<(
    { __typename?: 'CreatePushPayload' }
    & Pick<Types.CreatePushPayload, 'status'>
  )> }
);


export const FetchPushsDocument = gql`
    query FetchPushs($first: Int, $limit: Int, $after: String, $filter: PushsFilter, $sort: PushsSort) {
  pushs(first: $first, limit: $limit, after: $after, filter: $filter, sort: $sort) {
    edges {
      node {
        id
        uid
        title
        content
        link
        createdAt
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFetchPushsQuery__
 *
 * To run a query within a React component, call `useFetchPushsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPushsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPushsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFetchPushsQuery(baseOptions?: Apollo.QueryHookOptions<FetchPushsQuery, FetchPushsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPushsQuery, FetchPushsQueryVariables>(FetchPushsDocument, options);
      }
export function useFetchPushsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPushsQuery, FetchPushsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPushsQuery, FetchPushsQueryVariables>(FetchPushsDocument, options);
        }
export type FetchPushsQueryHookResult = ReturnType<typeof useFetchPushsQuery>;
export type FetchPushsLazyQueryHookResult = ReturnType<typeof useFetchPushsLazyQuery>;
export type FetchPushsQueryResult = Apollo.QueryResult<FetchPushsQuery, FetchPushsQueryVariables>;
export const CreatePushDocument = gql`
    mutation CreatePush($data: CreatePushInput!) {
  createPush(data: $data) {
    status
  }
}
    `;
export type CreatePushMutationFn = Apollo.MutationFunction<CreatePushMutation, CreatePushMutationVariables>;

/**
 * __useCreatePushMutation__
 *
 * To run a mutation, you first call `useCreatePushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPushMutation, { data, loading, error }] = useCreatePushMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePushMutation(baseOptions?: Apollo.MutationHookOptions<CreatePushMutation, CreatePushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePushMutation, CreatePushMutationVariables>(CreatePushDocument, options);
      }
export type CreatePushMutationHookResult = ReturnType<typeof useCreatePushMutation>;
export type CreatePushMutationResult = Apollo.MutationResult<CreatePushMutation>;
export type CreatePushMutationOptions = Apollo.BaseMutationOptions<CreatePushMutation, CreatePushMutationVariables>;